import {
  createHashRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';
import React from 'react';
import App from '../App';

const router = createHashRouter(
  createRoutesFromElements(
    <Route>
      <Route path="*" Component={App} />
      <Route path="/session/:sessionId" Component={App} />
    </Route>
  )
);

const Router = () => {
  return <RouterProvider router={router} />;
};

export default Router;
